import { CSSProperties } from "react";

export const XTypography = ({
  children,
  style,
  typographyStyle,
  className,
}: {
  children: React.ReactNode;
  style?: CSSProperties;
  className?: string;
  typographyStyle?: CSSProperties;
}) => {
  return (
    <span
      className={className}
      style={{
        display: "block",
        ...style,
      }}
    >
      <span
        style={{
          lineHeight: style?.lineHeight ?? "1.2em",
          marginTop: "0.2em",
          ...typographyStyle,
        }}
      >
        {children}
      </span>
    </span>
  );
};
